import "./Banner.scss";
import BannerImg from "../Banner/banner-img.png"

const Banner = () => {
    return (
    <div className="hero-banner">
        <div className="content">
            <div className="text-content">
                <h1>SALES</h1>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                    Architecto accusamus ea corporis error recusandae. 
                    Nostrum, optio dolores pariatur ipsum commodi vitae tenetur, 
                    quia ea sunt aliquam quo eaque consequatur voluptatum.
                </p>
                <div className="ctas">
                    <div className="banner-cta">Read More</div>
                    <div className="banner-cta v2">Shop Now</div>
                </div>
            </div>
            <img  className="banner-img" src={BannerImg} alt="headphone" />
        </div>
    </div>
    );
};

export default Banner;
